import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: 'pick-date.component.html'
})

export class PickDateComponent implements OnInit {
    constructor() { }

    ngOnInit() {  }
}


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/prescribe-vaccination/pick-date.component.ts